// pages/Settings.jsx
import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import toast from 'react-hot-toast';

function Settings() {
  const { theme, toggleTheme } = useTheme();
  const [settings, setSettings] = useState({
    notifications: true,
    autoRefresh: true,
    compactView: false,
  });

  const handleToggle = (key) => {
    setSettings({ ...settings, [key]: !settings[key] });
    toast.success(`${key} ${settings[key] ? 'disabled' : 'enabled'}`);
  };

  return (
    <div>
      <h2 style={{ marginBottom: '20px' }}>⚙️ Settings</h2>

      <div className="card">
        <div className="card-header">
          <span className="card-title">🎨 Appearance</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
          <div>
            <div style={{ fontWeight: '500' }}>Theme</div>
            <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
              {theme === 'dark' ? 'Dark Mode' : 'Light Mode'}
            </div>
          </div>
          <button className="btn btn-outline" onClick={toggleTheme}>
            {theme === 'dark' ? '🌙 Switch to Light' : '☀️ Switch to Dark'}
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">🔔 Preferences</span>
        </div>
        {Object.entries(settings).map(([key, value]) => (
          <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid var(--border-color)' }}>
            <div>
              <div style={{ fontWeight: '500', textTransform: 'capitalize' }}>
                {key.replace(/([A-Z])/g, ' $1').trim()}
              </div>
              <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
                {value ? 'Enabled' : 'Disabled'}
              </div>
            </div>
            <button className="btn btn-outline" onClick={() => handleToggle(key)} style={{ padding: '4px 16px' }}>
              {value ? 'Disable' : 'Enable'}
            </button>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">🗑️ Danger Zone</span>
        </div>
        <button className="btn btn-danger" onClick={() => toast.error('Account deletion coming soon')}>
          Delete Account
        </button>
        <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginTop: '8px' }}>
          This action cannot be undone.
        </p>
      </div>
    </div>
  );
}

export default Settings;